import { useEffect, useState } from "react";
import { CalendarIcon, Clock, CloseIcon, PlugIcon } from "../../../assets/icons";
import LayoutWrapper from "../../../layouts/landing-page-layout-wrapper/layoutWrapper";
import { useDeleteAllWihslistMutation, useDeleteWishlistItemMutation, useLazyGetWishlistsQuery } from "../../../service/wishlist-service";
import StoreTabSelector from "../layout/StoreTabSelector";
import styles from "./wishlist.module.scss";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../../stores/slices/loader-slice";
import ConfirmationDialog from "../../../common/components/dialog/ConfirmationDialog";
import { BounceLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
export const WishlistPage = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [getWishList, { data, isFetching }] = useLazyGetWishlistsQuery();
	const [deleteItem, { isLoading: deleteLoading }] = useDeleteWishlistItemMutation();
	const [deleteAllItems, { isLoading: deleteAllLoading }] = useDeleteAllWihslistMutation();
	const [selectedId, setSelectedId] = useState<string>("");
	const [showRemoveDialog, setShowRemoveDialog] = useState<boolean>(false);
	const [showRemoveAllDialog, setShowRemoveAllDialog] = useState<boolean>(false);

	useEffect(() => {
		dispatch(showLoader());
		getWishList()
			.unwrap()
			.then()
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => dispatch(hideLoader()));
	}, []);

	const toggleRemoveDialog = (id?: string) => {
		if (showRemoveDialog) {
			setSelectedId("");
		} else {
			setSelectedId(id ?? "");
		}
		setShowRemoveDialog(!showRemoveDialog);
	};

	const handleDelete = () => {
		deleteItem(selectedId)
			.unwrap()
			.then(res => toast.success("Item removed from wishlist"))
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => toggleRemoveDialog());
	};

	const handleDeleteAll = () => {
		deleteAllItems()
			.unwrap()
			.then(res => toast.success("All items removed from wishlist"))
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => setShowRemoveAllDialog(false));
	};

	const handleNavigate = (id: string) => {
		navigate(`/store/item/${id}`);
	};

	return (
		<>
			{showRemoveAllDialog && (
				<ConfirmationDialog
					title="Manage wishlist"
					description="Are you sure you want to remove all items?"
					onConfirm={handleDeleteAll}
					actionLoading={deleteAllLoading}
					btnText="Continue"
					onCloseDialog={() => setShowRemoveAllDialog(!showRemoveAllDialog)}
					btnBackGround="#ff7926"
				/>
			)}
			{showRemoveDialog && (
				<ConfirmationDialog
					title="Manage wishlist"
					description="Are you sure you want to remove item?"
					onConfirm={handleDelete}
					actionLoading={deleteLoading}
					btnText="Continue"
					onCloseDialog={toggleRemoveDialog}
					btnBackGround="#ff7926"
				/>
			)}
			<div className={styles.container}>
				<div className={styles.header}>
					<StoreTabSelector />
				</div>
				<LayoutWrapper>
					<div>
						<div className={styles.headRow}>
							<h3 className={styles.headText}>Wish List</h3>
							{isFetching && <BounceLoader size="25" title="Updating list..." />}
							{data && data?.length > 0 && (
								<button onClick={() => setShowRemoveAllDialog(!showRemoveAllDialog)} className={styles.removeButton}>
									Remove all
								</button>
							)}
						</div>
						{!data ||
							(data?.length === 0 && (
								<div className={styles.emptyList}>
									<h2 className={styles.cta}>Wihslist is empty</h2>
								</div>
							))}
						{data &&
							data?.length > 0 &&
							data?.map(item => {
								return (
									<div key={`${item?.id}-${item?.productName ?? item?.name}`} className={styles.wishlistItem}>
										<div className={styles.section}>
											<div className={styles.Image}>
												<img src={item?.images[0]?.imageUrl ?? ""} alt="Product" className={styles.productImage} />
											</div>
											<div className={styles.innerSection}>
												<div className={styles.productInfoSection}>
													<div className={styles.productDetails}>
														<h2 className={styles.productTitle}>{item?.name}</h2>
														<div className={styles.proBrand}>
															<p className={styles.brand}>
																Brand<span className={styles.brandName}> {item?.brand}</span>
															</p>
															<p className={styles.brand}>|</p>
															<p className={styles.availability}>
																Availability:{" "}
																{item?.available ? <span className={styles.inStock}>In Stock</span> : <span className={styles.inStock}>Out 0f Stock</span>}
															</p>
														</div>
														<div className={styles.divider}></div>
														<p className={`${styles.mobilePrice}`}>
															From <strong>&#8358;{item?.lowestPrice?.toLocaleString()}</strong>
														</p>
														<button
															onClick={() => handleNavigate(item?.id ?? "")}
															className={`${styles.viewDetailsButton} ${styles.desktopHide}`}
															style={{ marginBottom: 23, marginTop: 23 }}
														>
															View Details
														</button>
														<div className={styles.productInfo}>
															<span className={styles.item}>
																<Clock /> Up to {item?.activeDuration} HOURS
															</span>
															<span className={styles.item}>
																<CalendarIcon /> Up to a {item?.maximumNumberOfMonths} Months Plan
															</span>
															<span className={styles.item}>
																<PlugIcon /> {item?.capacity} KVA
															</span>
														</div>
													</div>
													<p className={`${styles.price} ${styles.mobileHide}`}>
														From <strong>&#8358;{item?.lowestPrice?.toLocaleString()}</strong>
													</p>
												</div>
												<div className={styles.buttonSection}>
													<button onClick={() => handleNavigate(item?.id ?? "")} className={`${styles.viewDetailsButton} ${styles.mobileHide}`}>
														View Details
													</button>
													<button className={styles.removeButton} onClick={() => toggleRemoveDialog(item?.id)}>
														Remove <CloseIcon />
													</button>
												</div>
											</div>
										</div>
									</div>
								);
							})}
					</div>
				</LayoutWrapper>
			</div>
		</>
	);
};

export default WishlistPage;
